import { alpha, TextField } from "@mui/material";
import { useContext } from "react";
import { Controller, useFormContext } from "react-hook-form";

import Context from "../context";

// ----------------------------------------------------------------------

type Props = {
	label: string;
	type: string;
	name: string;
	message?: string;
	onChange: (value: string) => void;
	disabled?: boolean;
};

export const TextInputField = ({ type, label, name, message, onChange, disabled }: Props) => {
	const { theme } = useContext(Context);
	const { control } = useFormContext();

	return (
		<Controller
			control={control}
			name={name}
			render={({ field, fieldState: { error } }) => (
				<TextField
					{...field}
					error={!!error}
					fullWidth
					disabled={disabled}
					variant='outlined'
					helperText={!!error ? error?.message : message}
					label={label}
					type={type}
					onChange={(event) => {
						field.onChange(event);
						onChange(event.target.value);
					}}
					size='small'
					onWheel={(event: any) => event.target.blur()}
					sx={{
						"& label": {
							color: theme?.colors?.primaryText ?? "white"
						},
						"& .MuiOutlinedInput-root": {
							"& fieldset": {
								borderColor: alpha(theme?.colors.stroke ?? "", 0.3)
							},
							"&:hover fieldset": {
								borderColor: !!error ? theme?.colors.mainError : theme?.colors.primary
							},
							"&.Mui-focused fieldset": {
								borderColor: !!error ? theme?.colors.mainError : theme?.colors.primary
							},
							"& input": {
								color: theme?.colors.primaryText
							}
						}
					}}
					InputLabelProps={{
						shrink: true,
						style: {
							color: !!error
								? theme?.colors.mainError
								: alpha(theme?.colors.secondaryText ?? "", 0.8)
						}
					}}
					FormHelperTextProps={{
						style: {
							color: !error ? theme?.colors.secondaryText : theme?.colors.mainError
						}
					}}
				/>
			)}
		/>
	);
};

export default TextInputField;
